module.exports = __webpack_public_path__ + "img/nitin-pro.649da6e6.jpg";